import type { Captain } from 'types/fpl/elements'

/** Denominator for league % columns — prefer API standings count, else sum of captain picks. */
export function resolveLeagueTeamCount(totalTeams: number, captains: Captain[]): number {
  if (totalTeams > 0) return totalTeams
  const fromCaptains = captains.reduce((sum, c) => sum + (c.count ?? 0), 0)
  return fromCaptains > 0 ? fromCaptains : 0
}

export function captainPct(count: number, totalTeams: number, captains: Captain[]): number {
  const n = resolveLeagueTeamCount(totalTeams, captains)
  return n > 0 ? (count / n) * 100 : 0
}
